import type { User } from 'firebase/auth';
import { onAuthStateChanged } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { auth } from '../firebase';
import { useAxiosInterceptors } from './useAxiosInterceptors';

export const useAuth = () => {
	const [user, setUser] = useState<User | null>(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const unsubscribe = onAuthStateChanged(auth, user => {
			setUser(user);
			setLoading(false);
		});

		return () => unsubscribe();
	}, []);

	// Configure axios interceptors with current user
	useAxiosInterceptors(user);

	return { user, loading };
};
